export const messages = {
  en: {
    storeStaff: {
      search: {
        title: 'Search Conditions',
        staffName: 'Staff Name',
        staffNamePlaceholder: 'Please enter staff name'
      },
      list: {
        title: 'Staff'
      },
      table: {
        name: 'Name',
        phone: 'Phone',
        position: 'Position',
        email: 'Email',
        address: 'Address',
        gender: 'Gender'
      },
      gender: {
        male: 'Male',
        female: 'Female'
      },
      fetchError: 'Failed to fetch staff list'
    },
    storeOrgTree: {
      fetchError: 'Failed to fetch organization tree'
    }
  },
  zh: {
    storeStaff: {
      search: {
        title: '查询条件',
        staffName: '员工名称',
        staffNamePlaceholder: '请填写员工名称'
      },
      list: {
        title: '员工'
      },
      table: {
        name: '名称',
        phone: '手机号',
        position: '岗位',
        email: '邮箱',
        address: '地址',
        gender: '性别'
      },
      gender: {
        male: '男',
        female: '女'
      },
      fetchError: '获取员工列表失败'
    },
    storeOrgTree: {
      fetchError: '获取组织树失败'
    }
  }
}